import type * as React from 'react';

import styles from '../style/betslip.module.css';

function LoadingBetslip(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={styles.loadingBetslip}
      height="204"
      id="loadingBetslip"
      version="1.1"
      viewBox="-2 -2 375.7 204"
      width="375.7"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse className={styles.fmst0} cx="185.9" cy="195.3" rx="185.9" ry="4.4"></ellipse>
      <path
        className={styles.fmst1}
        d="M66.8 36.6s-4.2.7-6.6 8.5c-2.4 7.9 1.1 25.6-1.2 28-2.4 2.4-18.8.7-21.3-1.8s-2-3.5-2-6-1.6-7.5-4.1-8.3c-2.5-.8 0 1.8 0 3.4 0 1.6-2.8.3-3.9 1.4-1.1 1.1-4.7 8.9-3.2 10.4s9.7 1.2 11.9 3.3c2.2 2.2 25 11.7 33.7 7.3 8.7-4.4-3.3-46.2-3.3-46.2z"
      ></path>
      <path
        className={styles.fmst2}
        d="M90.8 98.8l28.5 32.3c2.1 2.4 5.3 3.6 8.5 3.1l50.7-8.1s2.7 9.9 9 9.9h1.3l-8.3-18.1-3.6 2.5-50.5-1.6L111 86 90.8 98.8z"
      ></path>
      <path
        className={styles.fmst3}
        d="M104.7 69.3c-1.7-3.5-3.9-7.2-5.5-11.6-7.3-19.2-14.4-26-18.5-28.5-2-1.2-5.5-.6-7.6.3-4.2 2-10.4 6.1-10.4 14.4 0 11.6 4.2 21.9 17 30.4s15 17.4 15 17.4l10-22.4z"
      ></path>
      <path className={styles.fmst0} d="M62.7 44.3c2.2 24.2 17.2 27.1 25.5 36-7.7-6.6-26-12.6-25.5-36z"></path>
      <path
        className={styles.fmst1}
        d="M235.4 45.2s-2.3-2-4.3 0 3 29.8 0 29.8-17.5-3.3-19.6-5.4c-2.1-2.1-1.8-4.7-6.3-5.2s-1.9 2-.8 2c1.1 0 1.5.5 1.5 1s-2.7.2-3.5 1c-.8.8-.1 7.3 1.4 7.3s2.3-2.3 6.4-.9c4.1 1.4 25.3 12.3 29.6 9.1 4.3-3.3-4.4-38.7-4.4-38.7z"
      ></path>
      <path
        className={styles.fmst2}
        d="M233 42.1s.1 3.9-1.5 11.3-4.2 9.6 0 13.8c4.2 4.2 17.6 13.7 20.4 20.6 2.8 6.9 7.8 14.7 7.8 14.7l15.8-10.6S263.2 74.3 259 63.5c-4.2-10.8-15.1-23.8-16.1-24.8-1-1-9.9-1.3-9.9 3.4z"
      ></path>
      <path
        className={styles.fmst4}
        d="M231.8 27.6l11.1 11.1s-5.4 7.1-8.7 6.5c0 0-1.4-5.1-3.4-7.1s-5.8-3.6-4.9-3.6c.8 0 5.9-6.9 5.9-6.9z"
      ></path>
      <path
        className={styles.fmst1}
        d="M233.2 29l-1.4-1.4s-5.1 6.9-6 6.9c-.6 0 1.1.8 2.9 2 1.9-2.1 3.7-5.2 4.5-7.5z"
      ></path>
      <path
        className={styles.fmst2}
        d="M263.3 107s18.4 29.3 22.2 29.3c3.8 0 58.1-7.3 58.1-7.3s4.6 4.2 7.7 7.3c3.1 3.1 5.8 1.6 5.8 1.6s-6.8-10.9-7.6-14.2c-.8-3.4-2.4-3.4-2.4-3.4s-3.3 2.5-4.6 3.8c-1.3 1.3-42.5-2.1-45.2-2.1-2.7 0-7.6 2-7.6 2l-12.3-30-14.1 13z"
      ></path>
      <path
        className={styles.fmst5}
        d="M267 83.6c-4.7.8-51.3 39.8-51.3 39.8l-11.3 62s-2.8 2.5-6.8 4.4c-3.9 1.9-3.8 4.9-3.8 4.9H211s-.7-3.8-.7-6.1 16.3-46.3 16.3-52.1v-6.9s45.4-18.9 50.6-24.7c6.5-7.3 1.9-23.3-10.2-21.3z"
      ></path>
      <path className={styles.fmst3} d="M206.4 184l1 .3 13.3-59L276 86c-.3-.2-.5-.5-.8-.7l-55.4 39.4-13.4 59.3z"></path>
      <path
        className={styles.fmst3}
        d="M222.3 126.8L209.2 185l1 .3 13.1-57.9 55.4-37.7c-.2-.3-.3-.6-.5-.9l-55.7 37.9-.2.1z"
      ></path>
      <path
        className={styles.fmst3}
        d="M209.2 185l-1.8-.6-1-.3-1.7-.5-.3 1.8-.2.2 6.4 2.1c.1-.5.3-1.1.6-2l-1-.3-1-.4z"
      ></path>
      <path
        className={styles.fmst4}
        d="M207.7 68.1s-6.2-.7-6.5.1c-.6 1.8.3 1.5.3 2.5s-.5 1.1 0 1.5c.4.4.5.7.5 1.8 0 1 1.5 2.8 2 2.3s5.1-2.1 5.1-2.9c0-.8-3.1.4-3.1.4s3.5-1.5 3.5-2.1c0-.6-4.8.7-4.8.7s4.2-1 4.5-1.8c.3-.8-2.2-.7-4.7-.3 0 0 3-.3 3.8-1.2.8-.9-.6-1-.6-1zM240.7 45.9c0 7.3 24-2 24.8 5 .9 7-5.2 28.1-6.3 28.1s-4.8 2.2-4.8 3.8-.6 4.2.1 5c.8.8 1.3.4 2 .4s1.3.4 2.5.4 1.1.6 2.4.6 2.5-.2 2.9-3.3c.4-3 .2-4.6 1.3-6.8 1-2.2 9-28.6 7.4-36.4-1.7-7.7-32.3-4-32.3 3.2zM220.2 13.9s-3.6 2-3.6 5.3 2.2 4 2.2 5.9c0 1.9-3.3 3.6-3.3 3.6s.7 1.4 1.5 1.8c0 0-.2 1-.2 1.8 0 .7 1.1.6 1.1.6s-.6 1.1 0 1.3c.6.2.6.2.8.3.2.2.2.7.9 2.2.6 1.5 1.1 1.4 4.3 0 3.1-1.4 7.8-6.8 8.3-9.2.4-2.5 1-3.3.5-4.2-.5-.9-2.8-9.5-7-9.5-4.4.1-5.5.1-5.5.1z"
      ></path>
      <path
        className={styles.fmst6}
        d="M235.9 11.8s-4.4-4.2-8.4-3.5c-4 .7-5.4.8-7.6 1.7-2.2.9-2.6 4.2-1 5.1 1.7.9 7.4-1.4 9.1 2.4 1.7 3.8 2.2 4 2.4 3.7.3-.3.1-1.3.6-1.3s.8 7.1 1 7.9c.2.8 2.4 1.4 4.1-.8 1.7-2.2 3.3-8.8 1.8-12-1.4-3.1-2-3.2-2-3.2z"
      ></path>
      <path
        className={styles.fmst4}
        d="M229.4 21s.7-3.5 2.3-3c1.7.5 2.1 3.2 2.1 4.7s-2.2 2.6-3.4 1.4c-1.1-1-1-3.1-1-3.1z"
      ></path>
      <path
        className={styles.fmst6}
        d="M237.9 11.3s3.4-5.5 5.9-5.9c2.6-.4 6.7 1.7 8.2.6 1.5-1 1.4-1.9 1.4-1.9s1.2 1 1.6 2.3c.4 1.3-3.6 3-5.1 4-1.5.9-1.7 1.6-1.7 1.6s6.5 1.1 9.4-2.4c2.8-3.5 3.3-5.5 3.3-5.5s1.9 2.8 1.5 4.2c0 0 3.3-1.2 3.8-4.6.5-3.4-.3-4-.3-4s1.5.1 2.5 2 3.3.9 3.3.9.6 2.4-1.2 6.9c-1.7 4.5-11.8 8.3-16.1 10.2-4.3 1.8-8.6 2.7-11-.8-2.4-3.5-4.4-5-4.4-5l-1.1-2.6z"
      ></path>
      <path
        className={styles.fmst3}
        d="M237.2 9.3s-1.9-.2-1.7 2c.2 2.2 1.2 4.6 2.5 4.6 1.2 0 1.7-.6 2.1-2.6.2-2.1-1.1-4.7-2.9-4z"
      ></path>
      <path
        className={styles.fmst5}
        d="M112.6 81.9c-2.4-2.9-5.2-7-7.9-12.6l-11.9 8.5-41.4 40c-3.7 3.5-6 8.2-6.7 13.3l-7.4 55.6c-5.1 0-15.9 8.1-15.9 8.1l22.8-1.1-1.1-6.5 18.1-59c9-6.5 36.5-25.7 50-35.1 3.6-2.5 4.3-7.7 1.4-11.2z"
      ></path>
      <path
        className={styles.fmst4}
        d="M64.9 18.6s13.2 10.3 13.7 10.8-3.9 11-8 11.6c-4.1.7-4.3-2.4-4.7-4-.5-1.6-6.6-10.6-6.6-10.6l5.6-7.8z"
      ></path>
      <path
        className={styles.fmst1}
        d="M59.4 26.4s3.5 5.1 5.4 8.3c2-.8 5.6-3.5 3.7-12-.1-.6-.2-1.1-.4-1.6-1.9-1.5-3.2-2.5-3.2-2.5l-5.5 7.8z"
      ></path>
      <path
        className={styles.fmst4}
        d="M92.2 25.6s-14.8-1.7-17.4 6.8c-2.5 8.5 8.4 11.5 13.7 10.7 5.2-.8 17.7-8.6 21.7-6.7 4 1.9.1 23.4-1.8 25.3-1.9 1.9-6.2 3.2-7.9 4.9-1.7 1.7.9 2.7.9 2.7s0 .6.4 2c.5 1.4 1.7 1.6 1.7 1.6s1.1 2 3 2 4.4-6.7 6.9-10.6c2.4-3.9 9.2-27.2 6.1-36.1.1.1-22.1-2.1-27.3-2.6z"
      ></path>
      <path
        className={styles.fmst1}
        d="M75.5 30.8c-1.6 3.7-.9 7.4 2.7 9.6 8.3 5 14.4.7 21-1.9 2.9-1.1 8.1-3.3 11-2.2-3.2-.9-8 1.8-15.9 5.2-4.5 1.9-6.4 2.7-11.2 1.7-8.2-1.8-10.5-7.4-7.6-12.4z"
      ></path>
      <path
        className={styles.fmst4}
        d="M29.8 61.2s.1 2.3 1.7 3.9c1.7 1.7 1.1 2.6 0 2.6s-1.7-.5-1.7-.5 1.7 1.3 1.7 2.5-.5 2-2.4 1c0 0 1.9 1.3 1 2.2-.9.9-4 1.5-5.8-.7-1.8-2.2-.8-2.9-.6-4.2.2-1.4-.9-1.6.3-2.9 1.2-1.2 1.1-.7 1.7-2.3.6-1.6 3-3.7 4.1-1.6zM50.1 10.4s-3.2 2.7-.7 7.6c2.6 4.9 6.3 10 6.3 10l1.6-.8 4 3.6s6.3-.7 4.1-10.4c-2.2-9.7-.7-11.5-4.9-12.6-4.2-1-10.4 2.6-10.4 2.6z"
      ></path>
      <path
        className={styles.fmst2}
        d="M56.6 11.7s1 3-3.4 3.9c-4.4.9-6.4.4-6.4.4s1.4 1.8-3.7 2.5-7.8-2.6-7.5-6.1c.3-3.5 2.6-4.3 2.6-4.3l3.3 4.2-.4-5.5s1.6.4 2.2.4c.5 0 1.1 3.4 2.3 2.9 1.2-.4.6-3.8.6-3.8s2.6 2.6 3.2.7C50 4.7 52 3.7 52 3.7s-1.3 2 1.2 1.3 4.8-2.7 6.9-2.7c2.2 0 2.2 1.6 2.2 1.6s1.6-.2 3.7.3c2 .5 2.6 4.7 2.2 8.3-.4 3.6-1.3 7.4-.3 8.3.9.9 2.3.6 2.3.6s-2.4 2.9-3.9 1.4-1.7-3.8-2-5.8c-.3-1.9-1.1-4.1-1.8-2.9-.7 1.2.3 4.3-1.8 2.3s-2.4-4.4-2.6-4.7c-.4-.1-1.5 0-1.5 0z"
      ></path>
      <path className={styles.fmst4} d="M61.9 13s-1.7.9-1.1 2.8c.6 1.9 1.5 3.6 2.9 2.9 1.5-.8 1.9-6.7-1.8-5.7z"></path>
      <path
        className={styles.fmst7}
        d="M54.7 20.9c.2.3.2.7 0 .9-.2.2-.6 0-.8-.3-.2-.3-.2-.7 0-.9.2-.1.6 0 .8.3zM51.8 19.1s.3.8.6.8 1.1-.4 2-.4h1.3s-2.6-1.4-3.9-.4z"
      ></path>
      <g className={styles.fmst8}>
        <path className={styles.fmst2} d="M58.8 28.5l.2.2c.6-.7 1.2-1.6 1.2-2.6-.1 1-.7 1.8-1.4 2.4z"></path>
      </g>
      <path
        className={styles.fmst1}
        d="M62.4 14.2s-.9 1.4-.5 2.6c.4 1.1 1.2 1 1.9.4.6-.7.5-4-1.4-3zM231.6 19.5s-1.5 1.7-1 3c.6 1.4 1.4 1.3 2.1.6.8-.8.7-4.4-1.1-3.6z"
      ></path>
      <path className={styles.fmst9} d="M220.1 26.3s-1.1-.7-.6-2l.6 2z"></path>
      <path className={styles.fmst2} d="M216.5 23.8c1.8.3 5.2.5 6.5-.8-.8 1.8-4.5 2-6.5.8z"></path>
      <path className={styles.fmst9} d="M221.5 21.3s-2.7-.4-3.1 0c-.4.4-.1.8.1.8.3 0 1-.4 1.7-.4s1.3-.4 1.3-.4z"></path>
      <g className={styles.fmst8}>
        <path className={styles.fmst5} d="M217.8 33c.7-.1 1.3-.2 1.9-.5-.7.3-1.9.5-1.9.5z"></path>
      </g>
    </svg>
  );
}

export default LoadingBetslip;
